@import '../../colors.css';

.counter {
    font-size:125%;
    height: auto;
}

.counter[readonly] {
    background-color: white;
}

.btn.counterButton {
    touch-action: manipulation;
    background-color: #dddddd;
    height: 100%;
    padding: 2px 8px;
}

.btn.counterButton:active {
    filter: brightness(85%);
}

.btn.counterButton.red {
    background-color: var(--FIRST-red);
    color: white;
}

.btn.counterButton.blue {
    background-color: var(--FIRST-blue);
    color: white;
}

.input-group.counter-input-group {
    width: auto;
    max-width: 275px;
}

.input-group.counter-input-group input.form-control {
    min-width: 3em;
}

.counter-wrapper.conflict {
    background-color: yellow;
    border: 2px solid yellow;
    outline: 1px solid red;
}

.megaPenalty div {
    padding: 0.25em;
}

.megaPenalty {
    margin: 1em 0;
}

.flex-grow-space-1 {
    flex-grow: 1;
}

.flex-grow-space-5 {
    flex-grow: 5;
}

.megaPenaltyLabel {
    font-size: 1.2em;
}